export default Object.freeze({
    OWN: 'own',
    MASTER: 'master',
  })